import { useEffect } from "react";

import useQuestionnaireDomain from "@Totum/QuestionnaireBuilder/Domain/hooks/useQuestionnaireDomain";
import { useCurrentQuestionnaireDetails } from "@Totum/QuestionnaireBuilder/State/hooks/useCurrentQuestionnaireDetails";
import { useQuestionnaireQuery } from "@Totum/QuestionnaireBuilder/State/queries";

/**
 * Orchestrates the data for the `Form` component.
 * This interacts with the questionnaire domain and the server side state (react query).
 *
 * @param currentQuestionnaireId The ID of the current questionnaire
 */
const useFormData = (currentQuestionnaireId?: string) => {
    const [currentQuestionnaireDetails, setCurrentQuestionnaireDetails] = useCurrentQuestionnaireDetails();
    // ** Hooks ** //
    const { data: questionnaireDetails, isFetched } = useQuestionnaireQuery(currentQuestionnaireId);

    // ** Constants & Variables ** //
    const questionnaireDomain = useQuestionnaireDomain(currentQuestionnaireDetails);

    // ** Effects ** //

    // Update the context when data from the query changes
    useEffect(() => {
        setCurrentQuestionnaireDetails(questionnaireDetails?.value.questionnaire ?? undefined);
    }, [questionnaireDetails, setCurrentQuestionnaireDetails]);

    // ** Exports ** //

    return {
        // data
        questionnaire: {
            questionnaireId: questionnaireDomain.details.questionnaireId,

            // questionnaire flags
            isExistingQuestionnaire: Boolean(questionnaireDomain.isExistingQuestionnaire),
        },

        // state
        isFetched,
    };
};

export default useFormData;
